"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _zh_CN = _interopRequireDefault(require("../../action-sheet/locale/zh_CN"));

var _zh_CN2 = _interopRequireDefault(require("../../alert/locale/zh_CN"));

var _zh_CN3 = _interopRequireDefault(require("../../confirm/locale/zh_CN"));

var _zh_CN4 = _interopRequireDefault(require("../../date-picker/locale/zh_CN"));

var _zh_CN5 = _interopRequireDefault(require("../../date-picker-view/locale/zh_CN"));

var _zh_CN6 = _interopRequireDefault(require("../../date-select/locale/zh_CN"));

var _zh_CN7 = _interopRequireDefault(require("../../picker/locale/zh_CN"));

var _zh_CN8 = _interopRequireDefault(require("../../pull/locale/zh_CN"));

var _zh_CN9 = _interopRequireDefault(require("../../search-bar/locale/zh_CN"));

var _zh_CN10 = _interopRequireDefault(require("../../select/locale/zh_CN"));

var _zh_CN11 = _interopRequireDefault(require("../../keyboard/locale/zh_CN"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  locale: 'zh-cn',
  ActionSheet: _zh_CN.default,
  Alert: _zh_CN2.default,
  Confirm: _zh_CN3.default,
  DatePicker: _zh_CN4.default,
  DatePickerView: _zh_CN5.default,
  DateSelect: _zh_CN6.default,
  Picker: _zh_CN7.default,
  Pull: _zh_CN8.default,
  SearchBar: _zh_CN9.default,
  Select: _zh_CN10.default,
  Keyboard: _zh_CN11.default
};
exports.default = _default;